import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import Dealership from '../../../../../types/dealership/Dealership';
import DealershipWriteDTO from '../../../../../types/dealership/DealershipWriteDTO';
import { IsAdminDirective } from '../../../directives/is-admin.directive';
import { RoleNamePipe } from '../../../pipes/role-name.pipe';
import { DealershipService } from '../../../services/dealership.service';
import {
    UpdateDealershipDialogComponent
} from '../../shared/dealerships/update-dealership-dialog/update-dealership-dialog.component';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';

@Component({
    selector: 'app-dealership-detail',
    templateUrl: './dealership-detail.component.html',
    styleUrls: [ './dealership-detail.component.scss' ],
    imports: [
        RouterLink,
        PageHeaderComponent,
        UpdateDealershipDialogComponent,
        Button,
        RoleNamePipe,
        IsAdminDirective
    ]
})
export class DealershipDetailComponent implements OnInit {
    public dealership: Dealership | null = null;
    public editableDealership: DealershipWriteDTO = new DealershipWriteDTO({});
    public displayUpdateDialog = false;

    constructor(
        private route: ActivatedRoute,
        private dealershipService: DealershipService,
        private messageService: MessageService
    ) {
    }

    /**
     * Initializes the component.
     */
    public ngOnInit(): void {
        this.loadDealership();
    }

    /**
     * Opens the edit dialog.
     */
    public openEditDialog(): void {
        this.editableDealership = new DealershipWriteDTO(this.dealership ?? {});
        this.editableDealership.countryId = this.dealership?.country?.id;
        this.displayUpdateDialog = true;
    }

    /**
     * Reloads the dealership details.
     */
    public reloadDealershipDetails(): void {
        this.loadDealership();
    }

    /**
     * Confirms the deletion of the dealership.
     */
    public deleteDealership(): void {
        if (!this.dealership) {
            return;
        }

        const id = this.dealership.id;
        this.dealershipService
            .deleteDealership(id)
            .then(() => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Dealership deleted successfully',
                    life: 3000,
                });
                window.history.back(); // Navigate back after deletion
            })
            .catch((error: any) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.message,
                    life: 3000,
                });
            });
    }

    /**
     * Loads the dealership details from the service.
     */
    private loadDealership(): void {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            const idNumber = parseInt(id);
            this.dealershipService
                .getDealership(idNumber)
                .then((result: Dealership) => {
                    this.dealership = result;
                })
                .catch((error: any) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.message,
                        life: 3000,
                    });
                });
        }
    }
}
